import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';

import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW1404Model } from '../kymw1404/kymw1404.model';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { CodeCheckBoxListComponent } from '../../../commons/kymw02/list/code-check-box-list/code-check-box-list.component';
import { PlessDialogServiceSub } from 'src/app/commons/kymw00/pless-dialog-service-sub';

/**
 * 掲載候補商品検索画面を管理するクラス
 *
 * @export KYMW1405Component
 * @class KYMW1405Component
 */
@Component({
  selector: 'app-kymw1405',
  templateUrl: 'kymw1405.component.html',
  styleUrls: ['kymw1405.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1405Component extends PlessViewHelperSub implements OnInit {
  private readonly PCODE_LIST_MAX_COUNT = 1000;
  private readonly PCODE_LIST_DELIMETER = '\n';

  @ViewChild('li_DailyDiv', { static: true }) li_DailyDiv: CodeCheckBoxListComponent;

  closeFunction: Function = null;

  lstClassCode: Array<any> = new Array<any>();
  /* FlexのUI再現のため 最後にクリックされたIDを取得 */
  public lastClickId = String('');
  /**
   * Ｐコードリスト
   */
  public pcodes = '';

  /**
   * Ｐコード入力件数
   */
  public pcodeCounts = 0;

  /**
   * 商品案内用商品名
   */
  public guideGoodsName = String('');

  /**
   * 他媒体対象フラグ
   */
  public otherMediumTypeFlg = Boolean(false);

  public kymw1404Model: KYMW1404Model = null;

  /**
   * Creates an instance of KYMW1405Component.
   * @param {KYMW00Model} kymw00Model
   * @param {ElementRef} elementRef
   * @memberof KYMW1405Component
   */
  constructor(
    public kymw00Model: KYMW00Model,
    public elementRef: ElementRef,
    private dialogService: PlessDialogServiceSub,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW1405Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW1405';
    // Manageの内容を表示
    this.pcodes = PlessViewUtilsSub.arrayToString(this.kymw1404Model.pcodeList, this.PCODE_LIST_DELIMETER);
    this.setPcodeCounts(this.kymw1404Model.pcodeList);
    this.guideGoodsName = this.kymw1404Model.guideGoodsName;
    if (this.kymw1404Model.otherMediumTypeFlg === 1) {
      this.otherMediumTypeFlg = true;
    } else {
      this.otherMediumTypeFlg = false;
    }

    document
      .getElementById('txta_PCodes')
      .addEventListener('input', () => this.eventPcodesHandler());

    // 部門リストデータを表示用に変換
    const cmbClassCodeList: Array<any> = this.kymw1404Model.cmbClassCodeList;

    const lstClassCode: Array<any> = new Array<any>();
    for (let i = Number(0); i < cmbClassCodeList.length; i++) {
      // 部門コードが取得できない場合は除外
      if (PlessViewUtilsSub.isEmpty(cmbClassCodeList[i].ClassCode)) {
        continue;
      }

      const selClassCodeList: Array<any> = this.kymw1404Model.classCodeArray;
      let selEnable = false;
      for (let j = Number(0); j < selClassCodeList.length; j++) {
        // 前回選択されていたデータはチェックをつけて表示する
        if (cmbClassCodeList[i].ClassCode === selClassCodeList[j]) {
          selEnable = true;
        }
      }
      const labelStr: string = cmbClassCodeList[i].ClassCode + ' - ' + cmbClassCodeList[i].ClassName;
      lstClassCode.push({ lbl: labelStr, selectedValue: selEnable, code: cmbClassCodeList[i].ClassCode, index: i - 1 });
    }
    this.lstClassCode = lstClassCode;

    // 業態区分（デイリー）の選択状態を設定
    setTimeout(() => {
      this.bindDutiesFormDailyListHandler();
    });
  }

  /**
   * Ｐコードリストが変更されたときのイベント
   */
  public eventPcodesHandler(): void {
    const pcodeList = this.pcodes.split(this.PCODE_LIST_DELIMETER);
    this.setPcodeCounts(pcodeList);
    this.pcodes = PlessViewUtilsSub.arrayToString(pcodeList, this.PCODE_LIST_DELIMETER);
  }

  private setPcodeCounts(pcodeList: string[]) {
    this.pcodeCounts = pcodeList.length === 1 && pcodeList[0] === '' ? 0 : pcodeList.length;
    if (this.pcodeCounts > this.PCODE_LIST_MAX_COUNT) {
      this.pcodeCounts = this.PCODE_LIST_MAX_COUNT;
    }
  }

  /**
   * チェックが変更されたときのイベント
   *
   * @param {string} code
   * @param {boolean} selectedValue
   * @returns {void}
   * @memberof KYMW1405Component
   */
  public eventClassCode_CHANGEHandler(code: string, selectedValue: boolean): void {
    // 部門コードが取得できない場合は処理しない
    if (PlessViewUtilsSub.isEmpty(code)) {
      return;
    }

    const selClassCodeList: Array<any> = this.kymw1404Model.classCodeArray;
    // チェックありの場合はリストに追加
    if (selectedValue === true) {
      selClassCodeList.push(code);
    } else {
      // チェックなしの場合はリストから削除
      for (let i = Number(0); i < selClassCodeList.length; i++) {
        if (code === selClassCodeList[i]) {
          selClassCodeList.splice(i, 1);
        }
      }
    }
    // クリックされたIDをlastClickIdに保持する
    this.lastClickId = code;
  }

  /**
   * 検索ボタンが押下されたときのイベント
   *
   * @memberof KYMW1405Component
   */
  public eventSearch_CLICKHandler(): void {
    this.kymw1404Model.pcodeList = this.pcodes.split(this.PCODE_LIST_DELIMETER);
    this.kymw1404Model.guideGoodsName = this.guideGoodsName;
    if (this.otherMediumTypeFlg) {
      this.kymw1404Model.otherMediumTypeFlg = 1;
    } else {
      this.kymw1404Model.otherMediumTypeFlg = 0;
    }

    // 部門コードはチェック変更時にセットしているため、ここでは処理しない

    // 検索区分を設定
    this.kymw1404Model.processDiv = 1;

    // 業態区分デイリー選択値を保存
    const selectedDailyArray: Array<any> = new Array<any>();
    for (let i = Number(0); i < this.li_DailyDiv.codeCheckBoxListModel.codeList.length; i++) {
      if (this.li_DailyDiv.codeCheckBoxListModel.codeList[i].selectedValue === true) {
        selectedDailyArray.push(this.li_DailyDiv.codeCheckBoxListModel.codeList[i].CodeValue);
      }
    }
    this.kymw1404Model.dutiesFormDailyList = selectedDailyArray;

    // 親画面の検索を実行
    this.parent.dispatcherSearchEvent();

    // 画面を閉じる
    this.closeFunction();
  }

  /**
   * 業態区分（デイリー）のリスト更新時のハンドラ
   *
   * @private
   * @memberof KYMW1405Component
   */
  public bindDutiesFormDailyListHandler(): void {
    // 選択状態を設定
    for (let i = Number(0); i < this.kymw1404Model.dutiesFormDailyList.length; i++) {
      this.li_DailyDiv.updateCheckCodeValue(this.kymw1404Model.dutiesFormDailyList[i], true);
    }
  }
}
